import { FC } from 'react'
import { MyCourse } from '@models/myCourse'
import { AccordionHeaderProps } from '@molecules/Accordion'
import Text from '@organisms/Text'
import manyWords from '@utils/manyWords'
import InfoCounter from '@organisms/InfoCounter'
import GreenYellowStatus from '@templates/GreenYellowStatus'
import { ReactComponent as ArrowDownIconActive } from '@interface-images/select-arrow-down-active.svg'
import { ReactComponent as ArrowDownIcon } from '@interface-images/select-arrow-down-inactive.svg'
import { ReactComponent as ArrowUpIconActive } from '@interface-images/select-arrow-up-active.svg'
import { ReactComponent as ArrowUpIcon } from '@interface-images/select-arrow-up-inactive.svg'
import {
  HeaderWrapper,
  LeftWrapper,
  LineWrapper,
  StyledSubtitle,
  TitleText,
  RightContentWrapper,
  StatusBadgeWrapper,
  TitleRow,
  HeaderArrowWrapper,
  DeletedStatus,
  InfoRow,
  AvailabilityList,
  AvailabilityText,
} from './styled'

type Props = {
  item: MyCourse
  onClick?: () => void
} & AccordionHeaderProps

const Header: FC<Props> = ({
  hovered,
  expanded = false,
  item: {
    title,
    listenersCount,
    hoursCount,
    courseCategory,
    courseAvailabilities,
    published,
    deletedAt,
    isDeleted,
  },
  onClick,
}) => {
  const isCourseDeleted = isDeleted || !!deletedAt
  const employeesCount = listenersCount ?? 0
  let arrowIcon = hovered ? <ArrowDownIconActive /> : <ArrowDownIcon />

  if (expanded) {
    arrowIcon = hovered ? <ArrowUpIconActive /> : <ArrowUpIcon />
  }

  return (
    <HeaderWrapper hovered={hovered} onClick={onClick}>
      <LeftWrapper>
        <TitleRow>
          <LineWrapper>
            <StyledSubtitle>
              <TitleText>{title}</TitleText>
              <InfoCounter>{employeesCount}</InfoCounter>
            </StyledSubtitle>
          </LineWrapper>
        </TitleRow>
        <InfoRow>
          {courseCategory?.title && (
            <Text type="tag">{courseCategory.title}</Text>
          )}
          <Text type="tag">
            {manyWords(hoursCount, 'час', 'часа', 'часов')}
          </Text>
        </InfoRow>
        {!!courseAvailabilities?.length && (
          <AvailabilityList>
            {courseAvailabilities.map((availability) => (
              <AvailabilityText
                key={`${availability.company.id}-${
                  availability.companyBranch?.id ?? 'all'
                }`}
              >
                {availability.company.title}
                {availability.companyBranch
                  ? ` • ${availability.companyBranch.title}`
                  : ''}
              </AvailabilityText>
            ))}
          </AvailabilityList>
        )}
      </LeftWrapper>
      <RightContentWrapper>
        <StatusBadgeWrapper>
          {isCourseDeleted ? (
            <DeletedStatus>Удалён</DeletedStatus>
          ) : (
            <GreenYellowStatus
              success={published}
              successText="Опубликован"
              notSuccessText="Не опубликован"
            />
          )}
        </StatusBadgeWrapper>
        <HeaderArrowWrapper>{arrowIcon}</HeaderArrowWrapper>
      </RightContentWrapper>
    </HeaderWrapper>
  )
}

export default Header
